declare module 'pixi.js' {
  interface Container {
    /**
     * Fixed width value
     * If value doesnt set, returns width
     */
    ecWidth: number;

    /**
     * Fixed height value
     * If value doesnt set, returns height
     */
    ecHeight: number;

    /**
     * Update children recursively
     * @param dt Delta time
     */
    ecUpdateChildren(dt: number): void;
  }
}

import { Container } from 'pixi.js';

Object.defineProperty(Container.prototype, 'ecWidth', {
  get(): void {
    if (this._ecWidth !== undefined) {
      return this._ecWidth;
    }
    return this.width;
  },
  set(value: number): void {
    this._ecWidth = value;
  },
  enumerable: true
});

Object.defineProperty(Container.prototype, 'ecHeight', {
  get(): void {
    if (this._ecHeight !== undefined) {
      return this._ecHeight;
    }
    return this.width;
  },
  set(value: number): void {
    this._ecHeight = value;
  },
  enumerable: true
});

Container.prototype.ecUpdateChildren = function ecUpdateChildren(dt: number): void {
  for (const child of this.children) {
    child.ecUpdate(dt);
    if (child instanceof Container) {
      child.ecUpdateChildren(dt);
    }
  }
};

const destroy = Container.prototype.destroy;
Container.prototype.destroy = function (options?: {
  children?: boolean | undefined;
  texture?: boolean | undefined;
  baseTexture?: boolean | undefined;
}): void {
  if (options) {
    if (options.children === undefined) {
      options.children = true;
    }
    destroy.call(this, options);
  } else {
    destroy.call(this, { children: true });
  }
};
